{
    "onboarding": {
        "wizard": {
            "steps": {
                "company": {
                    "title": "Company Details",
                    "description": "Set up your company profile to get started"
                },
                "workEmail": {
                    "title": "Work Email",
                    "description": "Verify your work email and phone number"
                },
                "connectData": {
                    "title": "Connect to Your Data",
                    "description": "Link your accounting software for financial analytics"
                }
            },
            "actions": {
                "skip": "Skip for now",
                "continue": "Continue",
                "finish": "Go to Dashboard"
            }
        },
        "steps": {
            "personalInfo": {
                "title": "Personal information",
                "description": "Verify your identity to get started",
                "subSteps": [{
                        "label": "Upload Emirates ID"
                    },
                    {
                        "label": "Review personal information"
                    },
                    {
                        "label": "Verify work contact"
                    }
                ]
            },
            "companyVerification": {
                "title": "Company verification",
                "description": "Tell us more about your business",
                "subSteps": [{
                        "label": "Select company type"
                    },
                    {
                        "label": "Business registration"
                    },
                    {
                        "label": "Financial registration"
                    },
                    {
                        "label": "Review company details"
                    },
                    {
                        "label": "Sign letter of consent"
                    }
                ]
            },
            "allSet": {
                "title": "You're all set",
                "description": "Verification is complete!"
            }
        }
    },
    "page": {
        "LoginPage": {
            "title": "Welcome to Creditit",
            "description": "Enter your e-mail and password to login",
            "btn": "Login",
            "noAccount": " Don't have an account?",
            "signUp": "Sign up",
            "preferUaePass": "Prefer UAE Pass?",
            "noUaePass": "Don't have UAE Pass?",
            "signInWithEmail": "Sign in with email",
            "or": "OR",
            "testimonial": {
                "text": "\"Smarter financing, so we can focus on growing — not chasing payments.\"",
                "by": "Karen Yeu",
                "position": "CEO of Atomic Technology"
            }
        },
        "SignupPage": {
            "title": "Create your account",
            "description": "Enter your personal details to create an account",
            "btn": "Sign up",
            "alreadyAccount": "Already have an account?",
            "login": "Login"
        },
        "SignupSuccessPage": {
            "title": "Account successfully created!",
            "description": "We have just sent you an email with a link to verify your email address. Access that link to finish the enrollment"
        },
        "ThreeSixtyAnalysisPage": {
            "tab": {
                "moneyInOut": "Money in / Out",
                "profitAndSpend": "Profit & Spend",
                "cashTrends": "Cash Trends",
                "customerAndSalesHealth": "Customer & Sales Health"
            }
        },
        "VerifyEmailPage": {
            "success": {
                "title": "You verified your account",
                "description": "Continue setting up your account"
            },
            "failure": {
                "title": "There seems to be a problem with your link",
                "description": "Please recheck the link you have received in the email or contact us for support"
            },
            "goToLogin": "Go to the login screen"
        }
    },
    "component": {
        "CreditBreakdownCard": {
            "title": "Credit line overview",
            "tooltip": "A summary of your credit line, including your available credit limit, outstanding balance, and available to borrow",
            "creditLimit": {
                "label": "Current credit line",
                "tooltip": "Calculated as the sum of your collection account balance + 75% of the value of eligible invoices, up to the maximum facility limit"
            },
            "outstandingBalance": {
                "label": "Outstanding debt",
                "tooltip": "The amount of credit you have already borrowed"
            },
            "availableToBorrow": {
                "label": "Available to borrow",
                "tooltip": "The amount of credit you can still borrow"
            }
        },
        "LastCrmDataSyncDate": {
            "label": "Last update:",
            "tooltipError": "There was a problem with the latest data sync"
        },
        "LoadingCloud": {
            "title": "Processing documents",
            "description": "This step may take some time, please have patience..."
        },
        "NeedHelpBtn": {
            "preLabel": "Need help?",
            "label": "Get in touch with us"
        },
        "OpenApideckVault": {
            "cta": "Manage my connections"
        },
        "OrganizationSelector": {
            "title": "Organizations",
            "newOrganization": "New organization"
        },
        "ThreeSixtyAnalysisCustomerAndSalesHealth": {
            "topCustomers": {
                "title": "Top 5 Customers by Revenue",
                "tooltip": "Shows the top 5 customers ranked by revenue generated over the selected period. Helps identify your most valuable customers.",
                "noData": "No data available"
            },
            "concentrationRisk": {
                "title": "Customer Concentration Risk",
                "tooltip": "Shows what percentage of total revenue comes from your top 5 customers versus all others. High concentration indicates dependency risk.",
                "top5Customers": "Top 5 Customers",
                "noData": "No data available",
                "allOthers": "All Others"
            },
            "newCustomerRevenue": {
                "title": "New Customer Revenue",
                "tooltip": "Total revenue generated from customers acquired during the selected period."
            },
            "existingCustomerRevenue": {
                "title": "Existing Customer Revenue",
                "tooltip": "Total revenue generated from customers who were already active before the selected period."
            },
            "arpc": {
                "title": "Average Revenue Per Customer (ARPC)",
                "tooltip": "Average revenue generated per customer. Shows customer value and revenue efficiency."
            },
            "arpcTrend": {
                "title": "Average Revenue Per Customer (ARPC) Trend",
                "tooltip": "Shows the trend of average revenue per customer."
            }
        },
        "ThreeSixtyAnalysisOverview": {
            "cashRunway": {
                "title": "Cash Runway",
                "tooltip": "Cash Runway is a metric that measures the amount of cash a company has available to cover its expenses.",
                "footer": {
                    "title": "Cash Flow Trending Upward",
                    "monthlyBurnRate": "Net Monthly Burn Rate",
                    "cashBalance": "Cash Balance"
                }
            },
            "netProfitMargin": {
                "title": "Net Profit Margin",
                "tooltip": "Percentage of revenue remaining as profit after all expenses, taxes, and costs are deducted. Shows overall profitability."
            },
            "ARvsAP": {
                "title": "AR vs AP",
                "tooltip": "AR vs AP is the ratio of accounts receivable to accounts payable."
            },
            "DSO": {
                "title": "DSO",
                "tooltip": "DSO is the average number of days it takes to collect payments from customers."
            }
        },
        "ThreeSixtyAnalysisCashTrends": {
            "burnRateGauge": {
                "title": "Burn Rate %",
                "description": "Shows the percentage of monthly revenue consumed by net cash burn. \nA higher value means the company is spending faster relative to its revenue, while a lower value indicates more sustainable operations."
            },
            "runwayTrend": {
                "title": "Runway Trend",
                "description": "Shows how many months the company can continue operating at its current net burn rate, based on available cash. \nThe trend highlights whether runway is improving or shrinking over the past months."
            },
            "cashBalance": {
                "title": "Cash Balance",
                "description": "Shows the current cash balance of the company."
            },
            "monthlyBurnRate": {
                "title": "Monthly Burn Rate",
                "description": "Represents the net cash outflow in a given month. \nTracking this shows how quickly the company is using its cash reserves."
            }
        },
        "ThreeSixtyAnalysisProfitSpend": {
            "netIncome": {
                "title": "Net Income",
                "description": "Total profit after deducting all expenses, taxes, and costs from revenue."
            },
            "totalRevenue": {
                "title": "Total Revenue (MTD)",
                "description": "Total income earned this month to date from sales of products or services."
            },
            "grossMargin": {
                "title": "Gross Margin",
                "description": "Percentage of revenue left after deducting cost of goods sold, showing efficiency."
            },
            "revenueGrowth": {
                "title": "YoY Revenue Growth",
                "description": "Percentage change in revenue of last month compared to the same month last year."
            },
            "revenueProfitTrend": {
                "title": "Revenue and Profit Trend",
                "description": "Shows the trend of revenue and profit over time."
            },
            "marginTrends": {
                "title": "Gross and Net Margin Trends",
                "description": "Shows the trend of gross and net margin over time."
            }
        },
        "ThreeSixtyAnalysisMoneyInOut": {
            "netAccountsReceivables": {
                "title": "Net Accounts Receivables",
                "description": "Money customers still owe your business, after adjustments."
            },
            "netAccountsPayable": {
                "title": "Net Accounts Payable",
                "description": "Money your business still owes suppliers, after adjustments."
            },
            "dso": {
                "title": "Days Sales Outstanding",
                "description": "Average days it takes to get paid by customers."
            },
            "dpo": {
                "title": "Days Payable Outstanding",
                "description": "Average days your business takes to pay suppliers."
            },
            "dsoVsDpoTrend": {
                "title": "DSO vs DPO Trend",
                "description": "Shows the trend of days sales outstanding and days payable outstanding over time."
            }
        },
        "UAEPassCallback": {
            "title": "Logging in with UAE Pass",
            "description": "Please wait while we complete your authentication"
        }
    },
    "field": {
        "email": {
            "label": "Email",
            "placeholder": "Your email"
        },
        "password": {
            "label": "Password",
            "placeholder": "Your password"
        },
        "firstName": {
            "label": "First name",
            "placeholder": "Your first name"
        },
        "lastName": {
            "label": "Last name",
            "placeholder": "Your last name"
        },
        "currency": {
            "error": "Please select the organization's currency"
        },
        "amountDue": {
            "error": "Please fill in the sum of the invoice",
            "errorFormat": "Please provide a positive number with max 2 decimals"
        },
        "buyerId": {
            "error": "Please select a company"
        },
        "invoiceDueDate": {
            "error": "Please fill in the invoice due date"
        },
        "invoiceIssueDate": {
            "error": "Please fill in the invoice date"
        },
        "invoiceNumber": {
            "error": "Please fill in the invoice number"
        },
        "sellerId": {
            "error": "Please fill in the seller ID"
        },
        "vatPercentage": {
            "error": "Please fill in the VAT percentage",
            "errorFormat": "Please provide a number between 0 and 100 with max 2 decimals"
        },
        "invoiceVisibility": {
            "error": "Please fill in the invoice visibility"
        },
        "phoneNumber": {
            "label": "Phone number",
            "placeholder": "Your phone number",
            "error": "Please fill in your phone number",
            "invalid": "Invalid phone number"
        }
    },
    "general": {
        "appName": "Creditit",
        "close": "Close",
        "contactUs": "Contact us",
        "continue": "Continue",
        "expand": "Expand sidebar",
        "goToHomePage": "Go to home page",
        "hidePassword": "Hide password",
        "loginWithUAEPass": "Sign in with UAE PASS",
        "no": "No",
        "noData": "No data available",
        "pleaseTryAgain": "Please try again",
        "refresh": "Refresh",
        "showDetails": "Show details",
        "showPassword": "Show password",
        "signUpWithUAEPass": "Sign up with UAE PASS",
        "toggleTheme": "Toggle theme",
        "yes": "Yes"
    },
    "menu": {
        "general": {
            "360Analysis": "360 Analysis",
            "dataImport": "Data Imports",
            "aiChat": "AI Assistant"
        }
    },
    "dataImport": {
        "upload": {
            "title": "Manually import your data",
            "downloadTemplate": "Download Template",
            "uploadFile": "Upload File",
            "dropzone": "Drop your file here or click to browse",
            "maxSize": "Max file size: 10 MB",
            "fileTooLarge": "File is too large. Maximum size is 10 MB."
        },
        "mapping": {
            "title": "Review Column Mappings",
            "description": "Review and adjust how your columns map to our data fields",
            "sheet": "Sheet",
            "detectedType": "Detected Type",
            "confidence": "Confidence",
            "sourceColumn": "Source Column",
            "mapsTo": "Maps To",
            "unmapped": "Unmapped Columns",
            "missingRequired": "Missing Required Fields",
            "approveBtn": "Approve & Validate",
            "notes": "Notes"
        },
        "validation": {
            "title": "Validation Results",
            "totalRows": "Total Rows",
            "validRows": "Valid Rows",
            "errorRows": "Error Rows",
            "confirmBtn": "Confirm Import",
            "retryBtn": "Re-map Data",
            "warningPartial": "Some rows have errors. You can confirm the import with valid rows only, or go back to re-map the data."
        },
        "complete": {
            "title": "Import Complete",
            "description": "Your data has been successfully imported",
            "importedCounts": "Imported Records",
            "doneBtn": "Done"
        },
        "completeness": {
            "title": "Data Completeness",
            "missing": "Missing",
            "uploaded": "Uploaded",
            "notApplicable": "N/A",
            "markNa": "Mark as N/A"
        },
        "wizard": {
            "steps": {
                "upload": "Upload File",
                "mapping": "Review Mapping",
                "validation": "Validate",
                "complete": "Complete"
            }
        },
        "management": {
            "pageTitle": "Data Imports",
            "filterByStatus": "Filter by status",
            "allStatuses": "All Statuses",
            "columns": {
                "fileName": "File Name",
                "type": "Type",
                "status": "Status",
                "rows": "Rows",
                "imported": "Imported",
                "date": "Date",
                "actions": "Actions"
            },
            "actions": {
                "view": "View Details",
                "download": "Re-download File",
                "delete": "Delete"
            },
            "deleteDialog": {
                "title": "Delete Import",
                "description": "Are you sure you want to delete this import? This action cannot be undone."
            },
            "detail": {
                "title": "Import Details"
            },
            "empty": "No data imports found"
        },
        "status": {
            "pending": "Pending",
            "mapped": "Mapped",
            "validated": "Validated",
            "validation_failed": "Validation Failed",
            "importing": "Importing",
            "completed": "Completed",
            "failed": "Failed",
            "deleted": "Deleted"
        },
        "detectedType": {
            "invoices": "Invoices",
            "bills": "Bills",
            "customers": "Customers",
            "payments": "Payments",
            "profit-and-loss": "Profit & Loss",
            "balance-sheet": "Balance Sheet"
        }
    },
    "errors": {
        "required": "The field is required",
        "errorOccurred": "Sorry, an unexpected error has occurred.",
        "notFound": "Oops! We can’t find that one",
        "somethingWentWrong": "Something went wrong",
        "sessionExpired": "Your session has expired, please log in again",
        "userLoggedOut": "You have logged out",
        "password": {
            "minLength": "Password must be at least 8 characters long",
            "uppercase": "Password must contain at least one uppercase letter",
            "lowercase": "Password must contain at least one lowercase letter",
            "number": "Password must contain at least one number",
            "special": "Password must contain at least one special character"
        },
        "uaePassCancelled": "UAE Pass login was cancelled",
        "uaePassFailed": "Failed to complete UAE Pass authentication. Please try again."
    },
    "chart": {
        "labels": {
            "less30": "Less than 30 days",
            "30-60": "30 - 60 days",
            "60-90": "60 - 90 days",
            "more90": "More than 90 days",
            "notAging": "Not aging",
            "value": "Value",
            "items": "Items #",
            "totalAmount": "Total Value",
            "totalItems": "Total Number of Items"
        }
    },
    "aiChat": {
        "pageTitle": "AI Assistant",
        "inputPlaceholder": "Ask me about your finances...",
        "disclaimer": "AI responses may contain inaccuracies. Always verify important financial decisions.",
        "welcome": {
            "title": "Your AI Financial Assistant",
            "description": "Ask me anything about your business finances — revenue trends, cash flow, expenses, and more."
        },
        "actions": {
            "clearChat": "Clear chat"
        },
        "suggestions": {
            "revenueTrend": "Show my revenue trend",
            "expenseBreakdown": "Break down my expenses",
            "cashFlow": "Analyse my cash flow"
        }
    },
    "syncStatus": {
        "NEVER_SYNCED": "Never synced",
        "PROCESSING": "Processing...",
        "UNAVAILABLE": "Unavailable",
        "ERROR": "Error",
        "SUCCESS": "Success"
    },
    "service": {
        "acme": "Acme",
        "acumatica": "Acumatica",
        "clearbooks": "Clear Books",
        "exact": "Exact",
        "freeagent": "FreeAgent",
        "netsuite": "NetSuite",
        "procountor": "Procountor",
        "quickbooks": "QuickBooks",
        "sage": "Sage",
        "workday": "Workday",
        "xero": "Xero",
        "zoho-books": "Zoho Books"
    }
}